












































































































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import { Customer, DeleteCustomer } from "../../entities/customer";

export default Vue.extend({
  data: () => ({
    search: "",
    headers: [
      { text: "ID", value: "id", sortable: "false" },
      { text: "Nombre", value: "name", sortable: "true" },
      { text: "Prefijos", value: "prefixes", sortable: "true" },
      { text: "", value: "actions", sortable: "false" },
    ],
    openModalDelete: false,
    daysSelected: 0,
    days: [
      { text: "En 1 día", value: 1 },
      { text: "En 2 días", value: 2 },
      { text: "En 3 días", value: 3 },
      { text: "En 7 días", value: 7 },
    ],
    selectedCustomer: 0,
    modalCancelDelete: false,
  }),
  components: {},
  methods: {
    ediCustomer(customer: Customer) {
      this.$router.push(`/customers/edit/${customer.id}`);
    },

    deleteCustomer(id: number) {
      this.selectedCustomer = id;
      this.openModalDelete = true;
    },

    acceptCancelDeletion() {
      const payload: DeleteCustomer = {
        id: this.selectedCustomer,
        date: null,
      };
      this.$store.dispatch("customers/deleteCustomer", payload);
      this.modalCancelDelete = false;
    },

    cancelDeletion(id: number) {
      this.selectedCustomer = id;
      this.modalCancelDelete = true;
    },

    cancelConfirm() {
      this.openModalDelete = false;
      this.daysSelected = 0;
    },

    acceptDelete() {
      if (this.daysSelected > 0) {
        let dateNow = new Date();
        dateNow.setDate(dateNow.getDate() + this.daysSelected);

        const payload: DeleteCustomer = {
          id: this.selectedCustomer,
          date: dateNow.toISOString(),
        };

        this.$store.dispatch("customers/deleteCustomer", payload);
        this.cancelConfirm();
        dateNow = new Date();
      }
    },

    remainingDays(date: string) {
      const milliseconds = new Date(date).getTime() - new Date().getTime();
      const hours = Math.round(milliseconds / (1000 * 60 * 60));
      const days = Math.round(hours / 24);

      if (hours < 24) {
        return `${hours} ${hours === 1 ? "hora" : "horas"}`;
      }
      return `${days} ${days === 1 ? "día" : "días"}`;
    },

    newCustomer(): void {
      this.$router.push(`/customers/new`);
    },

    configCustomer(): void {
      this.$router.push(`/customers/config`);
    },

    disableCustomer(customer: Customer) {
      this.$store.dispatch("customers/disableCustomer", customer.id);
    },

    enableCustomer(customer: Customer) {
      this.$store.dispatch("customers/enableCustomer", customer.id);
    },
  },

  computed: {
    ...mapGetters("customers", {
      customers: "customersTable",
      loading: "customersLoading",
    }),
  },

  created() {
    this.$store.dispatch("customers/getCustomers");
  },
});
